export default __webpack_public_path__ + "static/media/Arm-straps of the Spheres.b8acf490.jpg";